// ** MUI Imports
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Navigation from "src/layouts/components/navigation/vertical";
import themeConfig from "src/configs/themeConfig";

// ** AppBar Imports
import AppBar from "./components/appBar";
import { useSettings } from "src/@core/hooks/useSettings";
import {
  Alert,
  AlertTitle,
  SpeedDial,
  SpeedDialAction,
  useMediaQuery,
} from "@mui/material";
import VerticalNavItems from "src/navigation/vertical";
import { useEffect, useRef, useState } from "react";
import Footer from "./components/shared-components/footer";
import BottomNavigation from "./components/shared-components/bottom-navigation";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Head from "next/head";
import Script from "next/script";
import { Phone } from "src/icons/core";
import { Instagram, Telegram } from "src/icons/socials";
import { SupportButton } from "./components/support";
// Styled component for Blank Layout with AppBar component

const BlankLayoutWithAppBarWrapper = styled(Box)(({ theme }) => ({
  height: "100vh",
  // textAlign: 'center',
  // For V1 Blank layout pages
  "& .content-center": {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(5),
    minHeight: `calc(100vh - ${theme.spacing(
      theme.mixins.toolbar.minHeight / 4
    )})`,
  },

  // For V2 Blank layout pages
  "& .content-right": {
    display: "flex",
    overflowX: "hidden",
    position: "relative",
    minHeight: `calc(100vh - ${theme.spacing(
      theme.mixins.toolbar.minHeight / 4
    )})`,
  },
}));

const ContentBox = styled(Box)(({ theme }) => ({
  // paddingTop: 31,
  // padding: '0 16px',
  paddingTop: theme.spacing(2 + theme.mixins.toolbar.minHeight / 6),

  [theme.breakpoints.up("md")]: {
    // padding: '0 30px',
    padding: "0 30px",

    paddingTop: theme.spacing(2 + theme.mixins.toolbar.minHeight / 2.1),
  },
  [theme.breakpoints.up("xl")]: {
    maxWidth: 1440,
  },
}));

const StyledToastContainer = styled(ToastContainer)(({ theme }) => ({
  "& .Toastify__toast": {
    fontFamily: "iranyekan !important",
  },
}));

const actions = [
  {
    name: "telegram",
    icon: <Telegram sx={{ color: "primary", fill: "primary" }} />,
  },
];

const BlankLayoutWithAppBar = (props) => {
  // ** Props
  const { children } = props;
  const { settings, saveSettings } = useSettings();

  // ** Props
  const { verticalLayoutProps } = props;

  // ** Vars
  const { skin, navHidden } = settings;
  const navigationBorderWidth = skin === "bordered" ? 1 : 0;
  const { navigationSize, disableCustomizer, collapsedNavigationSize } =
    themeConfig;
  const navWidth = navigationSize;
  const collapsedNavWidth = collapsedNavigationSize;

  const isShowMenu = useMediaQuery((theme) => theme.breakpoints.down("lg"));

  const hidden = useMediaQuery((theme) => theme.breakpoints.down("lg"));
  if (hidden && settings.layout === "horizontal") {
    settings.layout = "vertical";
  }

  // ** States
  const [navVisible, setNavVisible] = useState(false);

  // ** Toggle Functions
  const toggleNavVisibility = () => {
    setNavVisible((prev) => !prev);
  };

  // ** Ref
  const isCollapsed = useRef(settings.navCollapsed);
  useEffect(() => {
    if (hidden) {
      if (settings.navCollapsed) {
        saveSettings({ ...settings, navCollapsed: false, layout: "vertical" });
        isCollapsed.current = true;
      }
    } else {
      if (isCollapsed.current) {
        saveSettings({
          ...settings,
          navCollapsed: true,
          layout: settings.lastLayout,
        });
        isCollapsed.current = false;
      } else {
        if (settings.lastLayout !== settings.layout) {
          saveSettings({ ...settings, layout: settings.lastLayout });
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hidden]);

  const landingPageJsonLd = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    url: "https://www.mozono.ir/",
    name: "موزونو |‌ خرید از آمازون",
    alternateName: "Mozono",
    description:
      "موزونو |‌ خرید از آمازون ، پلتفرم خرید از آمازون امارات است که بهترین قیمت ، سریع ترین زمان تحویل ، تضمین کیفیت و اصل بودن کالا را به شما ارایه می کند هدف ما تسهیل خرید از آمازون به بهترین قیمت است.",
  };

  // For the organization details:
  const organizationJsonLd = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "موزونو |‌ خرید از آمازون",
    url: "https://www.mozono.ir",
    logo: "https://www.mozono.com/favicon.ico",
    sameAs: [
      // Your social profiles
      "https://www.linkedin.com/company/mozono/",
      "https://t.me/+-hhFXt4qvWIxYjhk",
      "https://instagram.com/mozono.ir?igshid=YmMyMTA2M2Y=",
      //... other social profiles
    ],
  };

  return (
    <BlankLayoutWithAppBarWrapper className="layout-wrapper">
      <AppBar
        hidden={hidden}
        navHidden={navHidden}
        settings={settings}
        toggleNavVisibility={toggleNavVisibility}
        saveSettings={saveSettings}
        navItems={VerticalNavItems}
      />

      {navHidden && !(navHidden && settings.lastLayout === "horizontal")
        ? null
        : isShowMenu && (
            <Navigation
              hidden={hidden}
              navWidth={navWidth}
              navVisible={navVisible}
              setNavVisible={setNavVisible}
              collapsedNavWidth={collapsedNavWidth}
              toggleNavVisibility={toggleNavVisibility}
              navigationBorderWidth={navigationBorderWidth}
              verticalNavItems={VerticalNavItems()}
              settings={settings}
              saveSettings={saveSettings}
              {...props}
            />
          )}
      {/* <MainBox
        className='app-content'
        sx={{
          mx: 'auto',
          // mt: theme => theme.spacing(theme.mixins.toolbar.minHeight / 4),
          position: 'relative',
          minHeight: theme => `calc(100vh - ${theme.spacing(theme.mixins.toolbar.minHeight / 4)})`
        }}
      >

      </MainBox> */}

      <ContentBox
        className="app-content"
        sx={{
          mx: "auto",
          // mt: theme => theme.spacing(theme.mixins.toolbar.minHeight / 4),
          position: "relative",
          minHeight: (theme) =>
            `calc(100vh - ${theme.spacing(
              theme.mixins.toolbar.minHeight / 4
            )})`,
        }}
      >
        {/* <Box sx={{ px: 3, my: 5 }}>
          <Alert severity="warning">
            <AlertTitle>اطلاعیه</AlertTitle>
            در حال حاضر اختلال های سراسری بر بستر دیتاسنترهای کشوری رخ داده است
            خواهشمندیم تا نتیجه گیری از سمت تیم فنی و برطرف کردن اختلال شکیبا
            باشید.
          </Alert>
        </Box> */}
        {children}
      </ContentBox>

      <Footer />
      <Box
        position={"fixed"}
        right={0}
        left={0}
        bottom={0}
        sx={{ display: { md: "none" }, zIndex: 10 }}
      >
        <BottomNavigation />
      </Box>
      <StyledToastContainer
        position="top-left"
        hideProgressBar={true}
        rtl={true}
      />
    </BlankLayoutWithAppBarWrapper>
  );
};

export default BlankLayoutWithAppBar;
